import { render } from "./SectionMusic.vue?vue&type=template&id=7c659ab5&scoped=true"
const script = {}

import "./SectionMusic.vue?vue&type=style&index=0&id=7c659ab5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c659ab5"]])

export default __exports__